import { call, put, select } from 'redux-saga/effects';
import { audioOnlyModeChanged, selectIsAudioOnlyMode } from 'features/application/applicationSlice';
import { localVideoToggled } from 'features/streaming/actions';
import { FeedMediaStates, RTCClient } from 'utils/webrtc';
import {
  paginationUpdated,
  selectPagination,
} from 'features/layout/features/pagination/paginationSlice';
import { SignalingSocket } from 'services/signaling';

export function* toggleAudioOnlyModeSaga() {
  const audioOnly: boolean = yield select(selectIsAudioOnlyMode);
  const nextAudioOnly = !audioOnly;

  yield put(audioOnlyModeChanged(nextAudioOnly));

  yield call(SignalingSocket.send, {
    event: 'audioOnlyModeChanged',
    data: { enabled: nextAudioOnly },
  });

  if (nextAudioOnly) {
    const mediaStates: FeedMediaStates = yield call(RTCClient.publishingFeed.getMediaStates);
    if (mediaStates.video.broadcasting) {
      yield put(localVideoToggled());
    }
  }

  // Re-run the camera reconcile through the single debounced pagination channel, so concurrent
  // toggles serialize and the latest state wins instead of racing direct updatePagination calls.
  const pagination: ReturnType<typeof selectPagination> = yield select(selectPagination);
  yield put(paginationUpdated(pagination));
}
